module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/yandex-ok/2.png?40f0be2291a679ef48d25b2e8eabd578";